<template>
  <!-- Manage Board Modal -->
  <BaseModal
    no-padding
    :no-exit="true"
    card-width="490px"
  >
    <template #toolbar>
      <div class="pt-6 p-5 flex flex-col gap-5 items-center justify-center w-full">
        <div class="bg-background-normal p-2 rounded-xl h-14 w-14">
          <img
            src="../../../assets/images/Calendar.png"
          >
        </div>
        <div class="text-center">
          <BaseText
            type="label"
            size="lg"
            class="text-text-loud"
          >
            {{ subscriptionEndReason.title }}
          </BaseText>
          <BaseText
            size="sm"
            class="text-text-normal max-w-xs"
          >
            {{ subscriptionEndReason.desc }}
          </BaseText>
        </div>
      </div>
    </template>

    <template #default>
      <div>
        <div class="relative flex items-center justify-center pt-10 pb-4 gap-3 overflow-hidden h-60">
          <!-- Nav btns -->
          <button
            class="w-9 h-9 rounded-full p-2 bg-background-normal absolute top-0 bottom-4 my-auto left-9 z-50 hover:bg-background-hover transition-colors shadow-sm"
            @click="activeReviewIndex = (activeReviewIndex - 1 + REVIEWS.length) % REVIEWS.length"
          >
            <ChevronIcon class="text-icon-muted rotate-90 transform" />
          </button>
          <div
            v-for="(review, rIndex) in REVIEWS"
            :key="review.name"
            :class="[
              'absolute duration-300 card-container',
              (rIndex === (activeReviewIndex + ACTIVE_OFFSET) % REVIEWS.length) ? 'z-10' : ''
            ]"
            :style="getReviewStyle(rIndex)"
          >
            <div
              class="rounded-2xl bg-white p-4 space-y-3 w-full h-full"
            >
              <div
                class="w-full"
              >
                <BaseText
                  size="xs"
                  class="text-text-loud flex-1  overflow-hidden text-ellipsis"
                  style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;"
                >
                  {{ review.desc }}
                </BaseText>
              </div>
              <div
                class="flex items-center gap-3"
              >
                <!-- <div class="w-11 h-11 rounded-full bg-red-300" /> -->
                <img
                  :src="review.imgURL"
                  class="w-11 h-11 rounded-full"
                >
                <div>
                  <BaseText
                    type="label"
                    size="xs"
                    class="text-text-muted"
                  >
                    {{ review.name }}
                  </BaseText>
                  <BaseText
                    size="xs"
                    class="text-text-normal"
                  >
                    {{ review.role }}
                  </BaseText>
                </div>
              </div>
            </div>
          </div>
          <button
            class="w-9 h-9 rounded-full p-2 bg-background-normal absolute top-0 bottom-4 my-auto right-9 z-50 hover:bg-background-hover transition-colors shadow-sm"
            @click="activeReviewIndex = (activeReviewIndex + 1) % REVIEWS.length"
          >
            <ChevronIcon class="text-icon-muted -rotate-90 transform" />
          </button>
        </div>
        <div class="w-full flex flex-col items-center justify-center gap-5 p-5">
          <button
            class="black-btn-primary rounded-md w-full text-white py-3 px-2.5"
            @click="SET_SUBSCRIPTION_DRAWER_VIEW_MODE({state: true})"
          >
            <BaseText
              type="label"
              size="sm"
            >
              Choose a Plan
            </BaseText>
          </button>
        </div>
        <div class="p-3 flex items-center justify-between border-t border-border-normal">
          <button
            class="hover:bg-background-normal transition-colors w-max px-2 py-1.5 rounded-md flex items-center gap-1 text-text-muted"
            @click="SET_SETTINGS_DRAWER_VIEW_MODE('billing')"
          >
            <SettingsIcon />
            <BaseText
              type="label"
              size="sm"
            >
              Settings
            </BaseText>
          </button>

          <BaseText
            v-if="getUser?.email"
            type="body"
            size="xs"
            class="text-text-subdued"
          >
            {{ getUser.email }}
          </BaseText>

          <button
            class="hover:bg-background-normal transition-colors w-max px-2 py-1.5 rounded-md flex items-center gap-1 text-text-muted"
            @click="handleLogout"
          >
            <BaseText
              type="label"
              size="sm"
            >
              Logout
            </BaseText>
            <LogoutIcon />
          </button>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import firebase from '@/api/config/FirebaseConfig'
import { mapActions, mapGetters, mapMutations } from 'vuex'
// Icons
import ChevronIcon from '../../globals/Icons/ChevronIcon.vue'
import SettingsIcon from '../../globals/Icons/SettingsIcons/SettingsIcon.vue'
import LogoutIcon from '../../globals/Icons/LogoutIcon.vue'
export default {
  name: 'TrialEndedModal',
  components: {
    ChevronIcon,
    SettingsIcon,
    LogoutIcon
  },
  data () {
    const REVIEWS = [
      {
        desc: "My team uses it daily. Creative communication between performance teams, clients and strategists has always been a massive bottleneck. Foreplay added structure & efficiency that simply let's everyone do their best work while cutting down needless back and forth.",
        name: 'Nick Shackelford',
        role: 'Founder @ Structured & Konstant Kreative',
        imgURL: require('../../../assets/images/people/nick-pfp.webp')
      },
      {
        desc: 'Foreplay is a key piece of how we find, save, review, and communicate around performance creative assets. It’s really reduced a lot of friction in the process and has allowed us to review and save 10x more content than we would have otherwise.',
        name: 'Connor MacDonald',
        role: 'CMO @ Ridge Wallet',
        imgURL: require('../../../assets/images/people/connor-pfp.webp')
      },
      {
        desc: 'This is the #1 tool in my toolkit. I use it daily for creative strategy research, compiling content ideas for clients, and even personal content development.',
        name: 'Dara Denney',
        role: 'Senior Director of Performance Creative',
        imgURL: require('../../../assets/images/people/dara-pfp.jpg')
      },
      {
        desc: 'We operate in a highly competitive market, and every time I use Spyder, it feels like an unfair advantage. We have been using it since beta, and easily 90% of our winning ads come from Spyder insights.',
        name: 'Stephen Hakami',
        role: 'Founder @ Wiza',
        imgURL: require('../../../assets/images/people/stephen-pfp.jpeg')
      },
      {
        desc: 'Foreplay is now my homepage. There is literally no better tool around to swipe ads and build boards of creative inspiration to share with my team. It easily saves us 1-2 hours per day.',
        name: 'Matthew Williams',
        role: 'CMO @ iStack / Affiliate World',
        imgURL: require('../../../assets/images/people/matthew-pfp.jpg')
      }
    ]
    const ACTIVE_OFFSET = 2
    return {
      REVIEWS,
      ACTIVE_OFFSET,

      activeReviewIndex: 0,

      selectedSubscription: {},
      subscriptions: [],
      loadingSubscriptions: false,
      loadingGoToStripe: false,
      step: 1
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUserSubscription', 'getUser']),
    subscriptionEndReason () {
      const isReturningUser = this.getUserSubscription?.isReturningUser ?? false
      if (isReturningUser) {
        return {
          title: 'Welcome back!',
          desc: 'Unlock access to your boards and all premium features by reactivating your subscription.'
        }
      }
      return {
        title: 'Your free trial has ended',
        desc: "You'll no longer be able to access your boards and exclusive features of Foreplay."
      }
    },
    getSortedSubscriptions () {
      const subs = [...this.subscriptions]
      return subs.sort((a, b) => (a.order > b.order ? 1 : -1))
    },
    getReviewStyle () {
      return (rIndex) => {
        const offset = ((rIndex - this.activeReviewIndex + this.REVIEWS.length) % this.REVIEWS.length - this.ACTIVE_OFFSET) * 240
        const centerIndex = this.getCenterIndex(this.activeReviewIndex)

        const rightIndex = this.getCenterIndex((this.activeReviewIndex + 1) % this.REVIEWS.length)
        const leftIndex = this.getCenterIndex((this.activeReviewIndex - 1 + this.REVIEWS.length) % this.REVIEWS.length)

        let rotation = 0
        if (centerIndex === rIndex) rotation = 0
        if (rightIndex === rIndex) rotation = 10
        if (leftIndex === rIndex) rotation = -10

        return {
          transform: `translateX(${offset}px) 
          rotate(${rotation}deg)
          translateY(${rIndex === centerIndex ? -20 : 0}px)
          scale(${rIndex === centerIndex ? 1.05 : 1})
            `,
          transition: 'opacity 0.3s ease, transform 0.3s ease',
          // When resetting for infinite scroll prevents being visible
          opacity: (rIndex === centerIndex || rIndex === rightIndex || rIndex === leftIndex) ? 1 : 0
        }
      }
    }
  },
  mounted () {
    this.fetchSubscriptions()
  },
  methods: {
    ...mapActions('AuthModule', ['logoutUser']),
    ...mapMutations('MiscModule', ['SET_SUBSCRIPTION_DRAWER_VIEW_MODE', 'SET_SETTINGS_DRAWER_VIEW_MODE']),
    getCenterIndex (index) {
      return (index + this.ACTIVE_OFFSET) % this.REVIEWS.length
    },
    // Handle Logout User
    handleLogout () {
      this.logoutUser()
    },
    async fetchSubscriptions () {
      this.loadingSubscriptions = true

      try {
        const db = firebase.firestore()

        const data = await db.collection('products').where('active', '==', true).get()

        for (let i = 0; i < data.docs.length; i++) {
          const currentDoc = data.docs[i].data()

          if (currentDoc.name === 'Additional Team Member (Annual)') {
            continue
          }

          const subscription = {
            ...currentDoc,
            perks: currentDoc.metadata.perks ? JSON.parse(currentDoc.metadata.perks) : [],
            price: [],
            order: currentDoc.metadata.order
          }

          const priceSnap = await data.docs[i].ref
            .collection('prices')
            .where('active', '==', true)
            .get()

          priceSnap.docs.forEach((doc, index) => {
            if (!index) {
              subscription.price = {
                ...doc.data(),
                id: doc.id
              }
            }
          })

          this.subscriptions.push(subscription)
        }
      } catch (e) {
        console.log(e)
        this.$showAlert({
          message: e,
          type: 'error'
        })
      } finally {
        this.loadingSubscriptions = false
      }
    }
  }
}
</script>

<style scoped>
.card-container{
  width: 360px;
  height: 136px;
  transform-origin: center center;
  border-radius: 16px;
  box-shadow: 0px 1px 2px 0px rgba(0, 56, 108, 0.08), 0px 0px 0px 1px rgba(0, 56, 108, 0.08);
}
</style>
